import Vue from "vue";

import { BootstrapVue } from 'bootstrap-vue'

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "vue2-advanced-search/dist/AdvancedSearch.css";
Vue.use(BootstrapVue)
